import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { type SpecialType } from "../../specialPreview.type";

export const SpecialSlide = ({ specials, currentIdx }: { specials: SpecialType[]; currentIdx: number }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();

    return (
        <Box position="relative" maxW="1040px" w="100%">
            <Flex>
                <Box
                    overflow="hidden"
                    maxW="728px !important"
                    // eslint-disable-next-line no-nested-ternary
                    w={isMobile ? "100%" : isLaptop ? "480px" : "100% !important"}
                    // eslint-disable-next-line no-nested-ternary
                    h={isMobile ? "256px" : isLaptop ? "640px" : "960px"}
                    borderBottomLeftRadius={isMobile ? "40px" : "88px"}
                >
                    <Flex
                        // eslint-disable-next-line no-nested-ternary
                        w={isMobile ? "100%" : isLaptop ? "480px" : "100%"}
                        // eslint-disable-next-line no-nested-ternary
                        h={isMobile ? "256px" : isLaptop ? "640px" : "960px"}
                        transform={`translateX(-${currentIdx * 100}%)`}
                        transition="transform 0.5s ease-in-out"
                    >
                        {specials.map((special) => (
                            <Center
                                flexShrink="0"
                                key={special.special_idx}
                                maxW="728px"
                                w="100%"
                                h="100%"
                                background={
                                    special.imgList[0]
                                        ? `url(${special.imgList[0].img_URL})no-repeat center/cover`
                                        : "gray.100"
                                }
                            >
                                {!special.imgList[0] && <Text>등록된 이미지가 없습니다</Text>}
                            </Center>
                        ))}
                    </Flex>
                </Box>
                <Text
                    alignSelf="flex-start"
                    color="#fff"
                    {...FONT("cormorant", isMobile ? 40 : 102, 700, 1.4)}
                    sx={{
                        writingMode: "vertical-rl",
                    }}
                >
                    SPECIAL
                </Text>
            </Flex>
            <Box position="absolute" overflow="hidden" right="0" bottom="0" pb="64px">
                <Flex
                    overflow="hidden"
                    display={isMobile ? "none" : "flex"}
                    w={isLaptop ? "320px" : "540px"}
                    h={isLaptop ? "256px" : "428px"}
                    // background="black"
                    borderTopLeftRadius="88px"
                >
                    {specials.map((special) => (
                        <Center
                            flexShrink="0"
                            key={special.special_idx}
                            maxW="728px"
                            w="100%"
                            h="100%"
                            background={
                                special.imgList[1] ? `url(${special.imgList[1].img_URL})no-repeat center/cover` : "none"
                            }
                            transform={`translateX(-${currentIdx * 100}%)`}
                            transition="transform 0.5s ease-in-out"
                        >
                            {/* {!special.imgList[1] && <Text>등록된 이미지가 없습니다</Text>} */}
                        </Center>
                    ))}
                </Flex>
            </Box>
        </Box>
    );
};
